import {
  ArchiveOutlined,
  DeleteOutline,
  EditOutlined,
  ListOutlined,
  QueryStatsOutlined,
  VisibilityOutlined,
} from '@mui/icons-material';
import { IconButton, Tooltip } from '@mui/material';

interface TableActionsProps {
  row: any;
  onAction: (event: React.MouseEvent, action: string, data: any, index: number) => void;
  actions?: string[];
  tooltips?: Record<string, string>;
}

const TableActions = ({ row, onAction, actions = ['edit', 'delete'], tooltips = {} }: TableActionsProps) => {
  const actionIcons = {
    edit: { icon: <EditOutlined />, color: 'primary', tooltip: 'Edit' },
    view: { icon: <VisibilityOutlined />, color: 'primary', tooltip: 'Preview' },
    delete: { icon: <DeleteOutline />, color: 'error', tooltip: 'Delete' },
    download: { icon: <ArchiveOutlined />, color: 'warning', tooltip: 'Download' },
    stats: { icon: <QueryStatsOutlined />, color: 'primary', tooltip: 'View Stats' },
    clipUses: { icon: <ListOutlined />, color: 'primary', tooltip: 'Show Uses' },
  };

  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
      {actions.map(
        (action) =>
          actionIcons[action] && (
            <Tooltip key={action} title={tooltips[action] ?? actionIcons[action].tooltip} placement="top" arrow>
              <IconButton color={actionIcons[action].color} onClick={(e) => onAction(e, action, row.original, row.index)}>
                {actionIcons[action].icon}
              </IconButton>
            </Tooltip>
          )
      )}
    </div>
  );
};

export default TableActions;
